<style lang="less" scoped>
  .menu-content {
    background-color: white;
  }
</style>
<template>
  <div>
    <v-btn
      fab
      small
      fixed
      @click="edit"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-menu
      offset-y
      content-class="menu-content"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          fab
          fixed
          style="margin-left: 50px"
          v-bind="attrs"
          v-on="on"
        >
          <span class="color-error">{{ unset_team_jobs_list.length }}</span>
        </v-btn>
      </template>
      <div class="color-error line text-center">
        未设置岗位 {{ unset_team_jobs_list.length }} 个
      </div>
      <v-list style="max-height: 300px; overflow: auto">
        <v-list-item
          v-for="item in unset_team_jobs_list"
          :key="`${item.team_id}-${item.id}`"
        >
          <v-list-item-title>{{ item.team_name }} - {{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!--<v-btn @click="getMappings">-->
    <!--  刷新-->
    <!--</v-btn>-->

    <VListContainer
      item-value="id"
      :items="mappings"
      :loading="loading"
      skeleton="article@3"
      style="padding-top: 45px"
    >
      <template v-slot="{ item }">
        <Card
          :mapping="item"
          style="margin: 10px 0"
          @edit="edit"
        />
      </template>
    </VListContainer>

    <Editor
      ref="editor"
      @update="updateMapping"
    />
  </div>
</template>
<script route="/wage_title_mapping/list">
  import Editor from './components/editor';
  import Card from './components/card';
  import VListContainer from '../../vuetify_custom/v-list-container';
  import {mapGetters} from "vuex";

  const teamJobHashKey = (team_id, job_id) => `${team_id}-${job_id}`;

  export default {
    components: { Editor, Card, VListContainer },
    data() {
      return {
        loading: false,
        mappings: [],
      }
    },
    computed: {
      ...mapGetters('async', [
        'teams_hash',
        'team_jobs_hash',
      ]),
      settled_team_jobs_flag() {
        const hash = {};
        this.mappings.forEach(mapping => {
          mapping.team_ids.forEach(team_id => {
            mapping.job_ids.forEach(job_id => {
              const key = teamJobHashKey(team_id, job_id);
              hash[key] = true;
            })
          })
        })
        return hash;
      },
      unset_team_jobs_list() {
        const list = [];
        Object.keys(this.team_jobs_hash).forEach(team_id => {
          const team = this.teams_hash[team_id] || {full_name: '-'};
          const jobs = team.del ? [] : this.team_jobs_hash[team_id];
          jobs.forEach(job => {
            const key = teamJobHashKey(team_id, job.id);
            if (!this.settled_team_jobs_flag[key]) {
              const item = this.$util.clone(job);
              item.team_id = team.id;
              item.team_name = team.full_name;
              list.push(item);
            }
          })
        })
        return list;
      }
    },
    created() {
      this.getMappings();
    },
    mounted() {
      //
    },
    methods: {
      edit(mapping) {
        this.$refs.editor.edit(mapping);
      },
      getMappings() {
        this.loading = true;
        this.$http.get('wage_title_mapping/all')
          .then((data) => {
            this.mappings = data.mappings;
          }).catch((e) => {
            console.warn(e);
          }).finally(() => {
            this.loading = false;
          });
      },
      updateMapping(mapping) {
        this.mappings.updateOrUnshift(mapping);
      }
    }
  }
</script>
